import React from 'react';
import MicrocredentialsCourseTopicManager from './MicrocredentialsCourseTopicManager';
import PerformanceTaskCourses from './PerformanceTask/PerformanceTaskCourses';
import { TeacherGuideCourses } from './TeacherGuide';
import { MicrocredentialsPerformanceTasks } from './PerformanceTask/PerformanceTasks';
import { StudentPerformanceTasks } from './PerformanceTask/StudentPerformanceTasks';
import { StudentPerformanceTaskSubjects } from './PerformanceTask/StudentPerformanceTaskSubjects';
import { MICROCREDENTIALS_TASK_MODES } from '../../config/microcredentialsTaskModules';

export function MicrocredentialsManagementPage() {
   return <MicrocredentialsCourseTopicManager />;
}

export function MicrocredentialsPerformanceTaskCoursesPage() {
   return <PerformanceTaskCourses mode={MICROCREDENTIALS_TASK_MODES.PERFORMANCE} />;
}

export function MicrocredentialsWrittenWorksCoursesPage() {
   return <PerformanceTaskCourses mode={MICROCREDENTIALS_TASK_MODES.WRITTEN_WORKS} />;
}

export function MicrocredentialsTeacherGuidePage() {
   return <TeacherGuideCourses />;
}

export function MicrocredentialsPerformanceTaskPage() {
   return <MicrocredentialsPerformanceTasks mode={MICROCREDENTIALS_TASK_MODES.PERFORMANCE} />;
}

export function MicrocredentialsWrittenWorksPage() {
   return <MicrocredentialsPerformanceTasks mode={MICROCREDENTIALS_TASK_MODES.WRITTEN_WORKS} />;
}

export function MicrocredentialsStudentPerformanceTaskPage() {
   return <StudentPerformanceTasks mode={MICROCREDENTIALS_TASK_MODES.PERFORMANCE} />;
}

export function MicrocredentialsStudentWrittenWorksPage() {
   return <StudentPerformanceTasks mode={MICROCREDENTIALS_TASK_MODES.WRITTEN_WORKS} />;
}

export function MicrocredentialsStudentPerformanceTaskSubjectsPage() {
   return <StudentPerformanceTaskSubjects mode={MICROCREDENTIALS_TASK_MODES.PERFORMANCE} />;
}

export function MicrocredentialsStudentWrittenWorksSubjectsPage() {
   return <StudentPerformanceTaskSubjects mode={MICROCREDENTIALS_TASK_MODES.WRITTEN_WORKS} />;
}
